import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  alignText: {
    textAlign: 'center',
  },
}));

const EmptyDataLabel = ({ label }) => {
  const classes = useStyles();

  return (
    <Typography variant="body2" color="textSecondary" component="p" className={classes.alignText}>
      {label}
    </Typography>
  );
};

EmptyDataLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default EmptyDataLabel;
